module.exports = __webpack_public_path__ + "img/logonative.f4e19746.png";